import Immutable from 'immutable';

export interface RawUpdateProject {
  projectid: string;
  name: string;
  code: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
  projectType: string;
  budget: string;
  countryCode: string;
}

export interface UpdateProjectData {
  projectid: string;
  name: string;
  code: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
  projectType: string;
  budget: string;
  countryCode: string;
}

const defaultValues: UpdateProjectData = {
  projectid: '',
  name: '',
  code: '',
  street: '',
  city: '',
  state: '',
  zipcode: '',
  projectType: 'PROJECT_TYPE_UNKNOWN',
  budget: 'BUDGET_UNSET',
  countryCode: '',
};

export const UpdateProjectFactory = Immutable.Record(defaultValues, 'Project');

export class UpdateProject extends UpdateProjectFactory {
  static deserialize(rawUpdateProject: RawUpdateProject): UpdateProject {
    return new UpdateProject({
      ...rawUpdateProject,
    });
  }

  serialize(): RawUpdateProject {
    return this.toJS();
  }
}
